import { handleException } from '~/modules/utilities/error_utilities';
import { logger } from '~/modules/utilities/logger';
import { notificationsStore, NotificationType } from '../stores/notificationStore';

export interface NotificationErrorException {
    error: unknown;
    context: string;
}

/**
 * Shows a success notification, unless options.exceptionInfo is provided, then it will show an error notification.
 */
export function sendNotification(
    message: string,
    options: {
        exceptionInfo?: NotificationErrorException;
        previousFocusedElement?: HTMLElement;
        title?: string;
        icon?: string;
        autoDismissMs?: number;
    } = {},
) {
    let notificationType = NotificationType.Success;
    const { previousFocusedElement, exceptionInfo, title, icon, autoDismissMs } = options;

    if (exceptionInfo) {
        const { error, context } = exceptionInfo;
        notificationType = NotificationType.Error;
        handleException(error, context);
    }

    if (notificationType === NotificationType.Success) {
        logger.info(message);
    } else {
        logger.error(message);
    }

    // @ts-expect-error * Automated Type Error Fix
    notificationsStore.addNotification(message, notificationType, { previousFocusedElement, title, icon, autoDismissMs });
}
